import React from 'react';
import EmptyCampaignIcon from './FlowchartCanvas/EmptyCampaignIcon';
import { NoResultsIcon } from '../../shared/filterUtils';

/**
 * Empty board, and the "no missions match these filters" state in focus mode.
 * Rendered outside the canvas so it does not zoom or pan.
 */
const FlowchartEmptyStates = ({
  taskCount,
  isFocusMode,
  isAnimatingIntoFocus,
  focusedTaskIds,
  isMultiCampaignMode,
  onShowAddMissionArrow,
}) => (
  <>
    {isFocusMode && !isAnimatingIntoFocus && focusedTaskIds && focusedTaskIds.size === 0 && (
      <div className="flowchart__focus-empty">
        <div className="flowchart__focus-empty-icon">
          <NoResultsIcon size={48} />
        </div>
        <h3>No matching missions</h3>
        <p>Try adjusting your filters to find missions</p>
      </div>
    )}

    {taskCount === 0 && !isFocusMode && (
      <div className="flowchart__empty">
        <div className="flowchart__empty-icon">
          <EmptyCampaignIcon size={64} />
        </div>
        {isMultiCampaignMode ? (
          <>
            <h3>No campaigns in this view</h3>
            <p>
              Drag campaigns from the left sidebar to add them to this view.
            </p>
          </>
        ) : (
          <>
            <h3>No missions yet</h3>
            <p>
              Click{' '}
              <button
                className="flowchart__empty-link"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onShowAddMissionArrow?.();
                }}
              >
                Add Mission
              </button>
              {' '}to create your first mission
            </p>
          </>
        )}
      </div>
    )}
  </>
);

export default FlowchartEmptyStates;
